import React from "react";
export default function FormLine(props) {
  return (
    <div className=" d-flex align-items-center">
      {props.label}
      <div className="flex-grow-1 ml-3">{props.children}</div>
    </div>
  );
}
